/**
  * @param {Object} object
  * @param {string} key
  * @return {any} value
 */
 export function getParameterCaseInsensitive(object, key, returnOnNull?) {
  const ret= object[Object.keys(object)
    .find(k => k.toLowerCase() === key.toLowerCase())
  ];
  return !ret ? returnOnNull : ret;;
}